export default function Table (props = {
    className: null
}) {
    return (
        <div
            className={`table ${props.className || ''}`
                .trim()}
            style={props.style || null}
        >
            <table>
                {props.children}
            </table>
        </div>
    )
}
